import { render, staticRenderFns } from "./MypageTicketTodayPane.vue?vue&type=template&id=cdc392b2&scoped=true"
import script from "./MypageTicketTodayPane.vue?vue&type=script&lang=ts"
export * from "./MypageTicketTodayPane.vue?vue&type=script&lang=ts"
import style0 from "./MypageTicketTodayPane.vue?vue&type=style&index=0&id=cdc392b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc392b2",
  null
  
)

export default component.exports